import { PagingState } from "../../common/interfaces/pagingParam.interface"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { CreateEmailTemplateInterface } from "../../common/interfaces/createEmailTemplate.interface"
import { SearchConditionState } from "../../common/interfaces/searchConditionParam"
import { SortColumnEnum } from "../../common/enum/sortColumn.enum"
import { SortOrderEnum } from "../../common/enum/sortOrder.enum"
import { SortConditionInterface } from "../../common/interfaces/sortCondition.interface"
import { handleSortOrder } from "../../common/helper/sortTable.helper"
import { FilterTableEnum } from "../../common/enum/filterTable.enum"

export interface CreateEmailTemplateState {
   requesting: boolean
   successful: boolean
   error: string
   data: CreateEmailTemplateInterface[]
   rowCount: number
   paging: PagingState
   searchCondition: SearchConditionState
   sortCondition: SortConditionInterface
}

const initialState: CreateEmailTemplateState = {
   requesting: false,
   successful: false,
   error: "",
   data: [],
   rowCount: 0,
   paging: {
      pageNumber: 1,
      pageSize: 5,
   },
   searchCondition: {
      option: FilterTableEnum.NONE,
      value: "",
   },
   sortCondition: {
      column: SortColumnEnum.NONE,
      order: SortOrderEnum.ASC,
   },
}

export const createEmailTemplate = createSlice({
   name: "createEmailTemplate",
   initialState,
   reducers: {
      requestCreateEmailTemplate: (state: CreateEmailTemplateState) => {
         state.requesting = true
      },
      getCreateEmailTemplateSuccess: (
         state: CreateEmailTemplateState,
         action: PayloadAction<any>
      ) => {
         state.requesting = false
         state.successful = true
         state.error = ""
         state.data = action.payload.data.data
         state.rowCount = action.payload.data.rowCount
      },
      getCreateEmailTemplateFail: (
         state: CreateEmailTemplateState,
         action: PayloadAction<any>
      ) => {
         state.requesting = false
         state.successful = false
         state.error = action.payload
         state.data = []
      },
      changePageNumberSuccess: (
         state: CreateEmailTemplateState,
         action: PayloadAction<number>
      ) => {
         state.paging.pageNumber = action.payload
      },
      changePageSizeSuccess: (
         state: CreateEmailTemplateState,
         action: PayloadAction<number>
      ) => {
         state.paging.pageNumber = 1
         state.paging.pageSize = action.payload
      },
      changeSearchConditionSuccess: (
         state: CreateEmailTemplateState,
         action: PayloadAction<any>
      ) => {
         state.paging.pageNumber = 1
         state.searchCondition.option = action.payload.option
         state.searchCondition.value = action.payload.value
      },
      changeSortConditionSuccess: (
         state: CreateEmailTemplateState,
         action: PayloadAction<any>
      ) => {
         state.sortCondition.order = handleSortOrder(
            state.sortCondition.column,
            action.payload.column,
            state.sortCondition.order
         )
         state.sortCondition.column = action.payload.column
      },
   },
})

export const {
   requestCreateEmailTemplate,
   getCreateEmailTemplateSuccess,
   getCreateEmailTemplateFail,
   changePageNumberSuccess,
   changePageSizeSuccess,
   changeSearchConditionSuccess,
   changeSortConditionSuccess,
} = createEmailTemplate.actions

export default createEmailTemplate.reducer
